import Link from 'next/link';
import { FC } from 'react';

import Button from 'components/common/button';
import { Flow } from 'components/common/flow';
import Image from 'components/common/image';
import { Heading5 } from 'components/common/text';
import { prepareTheme } from 'utils/theme';

import * as St from './styles';
import { IFluidCardProps } from './types';

export const FluidCard: FC<IFluidCardProps> = ({
  advert,
  logo,
  openInNewTab,
  loader,
  onClick,
}) => {
  if (!advert?.image || !advert.cta) return null;

  const { textHex, backgroundHex, text } = prepareTheme(advert.theme);

  return (
    <St.Wrapper
      fullBleedImage={!!advert.fullBleedImage}
      textHex={textHex}
      backgroundHex={backgroundHex}
    >
      <figure>
        <Image
          src={advert.image}
          aspectRatio={1}
          alt={advert.title}
          sizes="500px"
          loader={loader}
          objectFit="cover"
        />
        {logo && <St.Caption>{logo}</St.Caption>}
      </figure>
      <St.Content size="s-m">
        <Flow size="4xs-2xs">
          {advert.eyebrow && <St.Eyebrow step="1">{advert.eyebrow}</St.Eyebrow>}
          <Heading5 as="h2">{advert.title}</Heading5>
          {advert.teaser && <St.Body>{advert.teaser}</St.Body>}
        </Flow>
        <Link passHref href={advert.url}>
          <Button
            as="a"
            onClick={onClick}
            variant="secondary"
            colorScheme={text}
            {...(openInNewTab ? { target: '_blank', rel: 'noreferrer' } : {})}
          >
            {advert.cta}
          </Button>
        </Link>
      </St.Content>
    </St.Wrapper>
  );
};
